import { combineReducers, createStore, applyMiddleware } from "redux"
import { connectRouter } from "connected-react-router"
import thunk from "redux-thunk"
import { composeWithDevTools } from "redux-devtools-extension"
import { createBrowserHistory } from "history"
import reducers from "./reducers"

export const history = createBrowserHistory({ basename: '/portal-notary-frontend/' })


const rootReducer = combineReducers({
    router: connectRouter(history),
    ...reducers
})

export const store = createStore(
    rootReducer,
    composeWithDevTools(applyMiddleware(thunk))
)
